var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"video-responsive"}},[_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.src + '?title=0&byline=0&portrait=0&autoplay=1&autopause=0&loop=1&app_id=122963',"allowFullScreen":"","title":"Embedded Vimeo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }